module.exports = __webpack_public_path__ + "img/secondary-creation-btn.5fb18708.png";